import React from "react";
import { configurations } from "../../../configurations";
// import { configurations } from "../../configurations";

function CommonConfirmationProductSection({ type, title, items = [] }) {
  const icon = () => {
    switch (type) {
      case configurations.services.stay.value:
        return "/IconHotel2.svg";
      case configurations.services.flight.value:
        return "/IconFlight2.svg";
      case configurations.services.tour.value:
        return "/IconTour2.svg";
      case configurations.services.insurance.value:
        return "/IconInsurance2.svg";
      default:
        return "/IconTour2.svg";
    }
  };

  return (
    <div className="w-full flex flex-col">
      <div className="flex items-center gap-1 mb-1">
        <img src={icon()} alt="" className="h-5 object-contain" />
        <span className="text-xl font-bold">{title}</span>
      </div>
      <div className="w-full bg-[#F3F8FF] border-t-2 border-primary1 p-4 flex flex-wrap gap-2 justify-between">
        {items?.map((item, index) => (
          <div className="flex flex-col" key={index}>
            <span className="text-sm text-gray-500">{item?.label}</span>
            <span
              className={`text-sm ${
                item?.primary && "text-primary1"
              } font-bold`}
            >
              {item?.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CommonConfirmationProductSection;
